export default __webpack_public_path__ + "images/b8d81a7e9cdde63a5f667c829bf04397.png";